// extracted by mini-css-extract-plugin
module.exports = {"root":"google-app-badge_root__xDNY7","link":"google-app-badge_link__9hm8W","buttonImage":"google-app-badge_buttonImage__DaJ0l"};